import { basicPath } from '../basicPath';

export const fetchRelevantInfoMemberDaterangeStudentName = (params) => async (dispatch) => {
    // Detect portal from domain - use ReadingPlex endpoint on ReadingPlex domain
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    const path = `${prefix}/x-relevant-info/daterange-studentName`;
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}